import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setIdLineUp, setPitchLineupTemplate } from '../actions';
import Subheader from 'material-ui/Subheader';
import FlatButton from 'material-ui/FlatButton';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Strong = styled.span`
    color: #000;
`;

const subheaderStyle = {
    width: 'auto',
    paddingLeft: 0,
    paddingRight: 10
};

const flatButtonStyle = {
    fontSize: '14px'
};

class DisplayIdLineUp extends Component {
    state = {
        idLineUp:
            new URL(location.href).searchParams.get('idLineUp') ||
            this.props.idLineUp ||
            Math.floor(10000 + Math.random() * 90000)
    };

    componentDidMount() {
        let { idLineUp } = this.state;
        const { setIdLineUp, setPitchLineupTemplate } = this.props;
        const ttId = new URL(location.href).searchParams.get('ttId');
        idLineUp = parseInt(idLineUp, 10);
        history.pushState({}, '', `?${ttId ? `ttId=${ttId}&` : ''}idLineUp=${idLineUp}`);

        fetch(`http://ss2.si-ab.com/admin/keyval?appName=maker-tool&key=${idLineUp}`)
            .then(res => res.status === 200 && res.json())
            .then(lineup => {
                if (lineup && lineup.value) {
                    setIdLineUp(idLineUp, false);
                    setPitchLineupTemplate(lineup.value.players || []);
                } else {
                    setIdLineUp(idLineUp);
                }
            });
    }

    fallbackLinkTextToClipboard(text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    copyLinkToClipboard = () => {
        const link = location.href;

        if (!navigator.clipboard) {
            this.fallbackCopyTextToClipboard(link);
            return;
        }

        navigator.clipboard.writeText(link).catch(err => {
            console.error('Async: Could not copy text: ', err);
        });
    };

    render() {
        return (
            <Wrapper>
                <Subheader style={subheaderStyle}>
                    <Strong>LineUp Id: </Strong>
                    {location.href}
                </Subheader>
                <FlatButton style={flatButtonStyle} onClick={this.copyLinkToClipboard}>
                    Copy Link
                </FlatButton>
            </Wrapper>
        );
    }
}

DisplayIdLineUp.propTypes = {
    // From connect
    idLineUp: PropTypes.number,
    setIdLineUp: PropTypes.func.isRequired,
    setPitchLineupTemplate: PropTypes.func.isRequired
};

export default connect(
    ({ makerToolPage: { idLineUp } = {} }) => ({ idLineUp }),
    { setIdLineUp, setPitchLineupTemplate }
)(DisplayIdLineUp);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/DisplayIdLineUp.js
 **/